import React, { useEffect, useState, useCallback } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { adminServices } from "../../services/adminServices";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import _ from "lodash";
import TableListing from "../common/tableListing";
import Filter from "../filter/filter";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined"; 
import { Backdrop, CircularProgress } from "@mui/material";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import topArrow from '../../assests/images/top.png';
import topHighlightArrow from '../../assests/images/top-highlighted.png';
import bottomArrow from '../../assests/images/bottom.png';
import bottomHighlightArrow from '../../assests/images/bottom-highlighted.png'; 
import { Link , useNavigate} from "react-router-dom";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import Stack from "@mui/material/Stack";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Tooltip from '@mui/material/Tooltip';
import { getSecPermission, isEmptyDash, strToDate,trimString } from "../../constant"; 
import SwapVertIcon from '@mui/icons-material/SwapVert';

const requestPayloadInitials = {
  pageNumber: 1,
  pageSize: 10,
  sortArray: [],
  searchCriteria: [],
};
const vendorListObj = {
  totalItems: 0,
  totalPages: 0,
  currentPage: 0,
  pageSize: 0,
  vendors: [],
};

const style1 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  right: "50%",
  transform: "translate(-50%, -50%)",
  width: "40%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  marginTop: "5rem",

};

const initialColumns = [
  { id: "name", label: "API Name", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT"},
  { id: "serviceProvider", label: "Service Provider", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "date", label: "Date", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "DATE" },
  { id: "referenceKey", label: "Refrence Key", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "time", label: "Time", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "requestBody", label: "Request Payload", isSort: false, sortLabel: "", isSearchInput: false, inputText: "", formate: "MODAL_TEXTAREA" },
  { id: "response", label: "Response", isSort: false, sortLabel: "", isSearchInput: false, inputText: "", formate: "MODAL_TEXTAREA" },
  { id: "status", label: "Status", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "statusCode", label: "Status Code", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "error", label: "Error Msg (If failed)", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  // { id: "col10", label: "Actions", isSort: true, sortLabel: "" },
];

function LogsApi() {
  const [requestPayload, setRequestPayload] = useState(requestPayloadInitials);
  const [logList, setAdminLogList] = useState({ apiLogs: [] });
  const [isLoading, setIsLoading] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [isRequestModalOpen, setIsRequestModalOpen] = React.useState(false);
  const [selectedResponse, setSelectedResponse] = useState('');
  const [selectedRequest, setSelectedRequest] = useState([]); 
  const [inputPage, setInputPage] = useState(logList?.currentPage || 1);
  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });

  const onFilterSubmit = () => {
    getAdminLogList(requestPayload, filterText);
  };

  const onKeyPressHandler = (e) => {
    e.persist();
    if (e.key === "Enter") {
      onFilterSubmit();
    }
  };

  const onFilterTextChange = (e) => {
    let { value } = e.target;
    setFilterText(value);
    debouncedSearch(value);
  };
  const debouncedSearch = useCallback(
    _.debounce((searchTerm) => {
      let requestPayloadInit = _.cloneDeep(requestPayload);
      requestPayloadInit.pageNumber = 1;
      setRequestPayload(requestPayloadInit);
    }, 800),
    []
  );
  useEffect(() => {
    getAdminLogList(requestPayload, filterText,filterFormData);
  }, [requestPayload]);

  const getAdminLogList = (requestPayloadParam, filterTextParam , formData) => {
    setIsLoading(true);
    let param = `?page=${requestPayloadParam?.pageNumber}&pageSize=${requestPayloadParam?.pageSize}&search=${filterTextParam}`;
    if (requestPayloadParam.sortArray.length > 0) {
      param += `&sortBy=${requestPayloadParam.sortArray[0]}&sortOrder=${requestPayloadParam.sortArray[1]}`;
    }
    const filteredFormData = formData ? Object.entries(formData)
      .filter(([key, value]) => value !== '')
      .reduce((acc, [key, value]) => {
        acc[key] = value;
        return acc;
      }, {}) : {};
    if (filteredFormData && Object.keys(filteredFormData).length > 0) {
      Object.entries(filteredFormData).forEach(([key, value]) => {
        param += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
      });
    }
    adminServices
      .getAdminLogList(param)
      .then((res) => { 
        if (res.data.success == true) {
          setAdminLogList(res?.data?.data);
        } else {
          setAlertComponent({
            open: true,
            type: "error",
            message: `No Data Found `,
          });
        }
      })
      .catch(function (error) {
        setAlertComponent({
          open: true,
          type: "error",
          message: `${error?.response?.data?.message}`,
        });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  }

  const handleModalOpen = (row, rowIndex) => {
    setSelectedResponse(row.response);
    setIsModalOpen(true);
  };

  const handleRequestModalOpen = (row, rowIndex) => {
    setSelectedRequest(JSON.stringify(row.requestBody, null, 2));
    setIsRequestModalOpen(true);
  };

  const tableStyle = {
    width: '100%',
  };
  
  const handleModalClose = () => { setIsModalOpen(false); setSelectedResponse(''); }
  const handleRequestModalClose = () => { setIsRequestModalOpen(false); setIsRequestModalOpen(''); }
  

  const [filterFormData, setFilterFormData] = useState("");
  const [activeFilters, setActiveFilters] = useState([]);
  const [columns, setColumns] = useState(initialColumns);
  const [isFilterTabOpen, setIsFilterTabOpen] = useState(false);
 

   
  
  let navigate = useNavigate();
  const navigateUrl = (param) => {
    navigate(param);
  };
  
  const onPaginationChange = (e, value) => {
    let requestPayloadInit = _.cloneDeep(requestPayload);
    requestPayloadInit.pageNumber = value;
    setRequestPayload(requestPayloadInit);
  }
  
  const dummyFun = (param) => {  };
  
  const onFilterChange = (formDataParam, textParam) => {
    setFilterFormData(formDataParam);
    setFilterText(textParam);
  }
  
  return (
    <>
      <div class="login-forms">
        <div class="text-centers">
          <p className="api_logs_vendors_reacts_colums">API Logs</p>
              <TableListing
                column={initialColumns}
                listingArrName="apiLogs"
                filterKeyName={"API_LOGS"}
                componentName="API_LOG"
                promiseRequest={adminServices.getAdminLogList}
                onFilterChange={onFilterChange}
                promiseUrlType="LIST"
                additionalData={{
                  isMaster: false,
                  type: "PO Modification Request",
                  isTrackOrder: false,
                  isFilter: true,
                  isSearch: true,
                  isPagePerSize: true,
                  isPagination: true,
                  isDragable: true,
                  isDownload: true,
                }}
            />

          <Modal
            open={isModalOpen}
            onClose={handleModalClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h1 className="modal-title fs-5" id="exampleModalLabel">
                      Response
                    </h1>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      fdprocessedid="kum8iho"
                      onClick={handleModalClose}
                    ></button>
                  </div>
                  <div class="modal-body vrf-h-flow" style={{ height: "190px", textAlign: "left", paddingTop: "21px" }}>
                    <div class="vendor_registration_form ">
                      <div>
                        {selectedResponse}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Box>
          </Modal>

          <Modal
            open={isRequestModalOpen}
            onClose={handleRequestModalClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h1 className="modal-title fs-5" id="exampleModalLabel">
                      Request
                    </h1>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      fdprocessedid="kum8iho"
                      onClick={handleRequestModalClose}
                    ></button>
                  </div>
                  <div class="modal-body vrf-h-flow" style={{ height: "190px", textAlign: "left", paddingTop: "21px" }}>
                    <div class="vendor_registration_form ">
                      <div>
                        {selectedRequest}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Box>
          </Modal>


        </div>
      </div>

    </>

  );
}

export default LogsApi;
